import { Request } from '~/infrastructure/mam/ApiClient';
import { ErpScenarioInterventionResponse, InterventionTypeSerializable } from 'com.cogvio.pricemonitor.api';
import { CountryCode } from '~/UI/CountryIcon/CountryIcon';

export enum InternalServerError {
	'internal-server-error' = 'internal-server-error',
}

export enum ERPInterventonNameError {
	'erp-scenario-already-exists' = 'erp-scenario-already-exists',
}

const ReadableErrorCodes: { [maybeErrorCode: string]: string } = {
	[ERPInterventonNameError['erp-scenario-already-exists']]: 'This name is already taken by some other scenario!',
};

export type ERPScenarioCreateError = InternalServerError | ERPInterventonNameError;

export const InterventionType: { [key in InterventionTypeSerializable]: InterventionTypeSerializable } = {
	'price-change': 'price-change',
	delist: 'delist',
	launch: 'launch',
};

export const IterventionTitles: Map<InterventionTypeSerializable, string> = new Map([
	[InterventionType['price-change'], 'Price intervention'],
	[InterventionType['delist'], 'Delist'],
]);

export const getHumanReadableErrorCode = (codes: Set<string>): string[] => {
	return Array.from(codes)
		.map((errorCode) => ReadableErrorCodes[errorCode])
		.filter(Boolean);
};

export type ERPInterventionEditData = {
	countryCode: CountryCode | string;
	type: InterventionTypeSerializable;
	month: string; // YYYY-MM
	price: {
		value: string;
		currency: string;
	} | null;
};

export class ERPInterventionCreateRequest implements Request<ErpScenarioInterventionResponse, ERPScenarioCreateError> {
	public readonly knownErrorCodes = Object.values({ ...InternalServerError, ...ERPInterventonNameError });
	public readonly path: string;
	public readonly method = 'put';
	public readonly body: BodyInit | null = null;

	public constructor(
		userId: string,
		erpPackId: string,
		erpSessionId: string,
		scenarioId: string,
		data: ERPInterventionEditData[]
	) {
		this.path = `users/${userId}/erp/packages/${erpPackId}/sessions/${erpSessionId}/scenarios/${scenarioId}/interventions`;
		this.body = JSON.stringify(data);
	}
}
